import { Component, inject } from '@angular/core';
import { Dialog, IDialogData } from '../dialog';
import { EEntityType, ERelationType } from '@web/dtos';
import { ReactiveFormsModule } from '@angular/forms';
import { WebTextStore } from '../../../services/api/text/web-text-store.service';
import { DialogComponent } from '../dialog/dialog.component';
import { FilterTextsPipe } from '../../../pipes/filterTexts/filterTexts.pipe';
import { LanguagePipe } from '../../../pipes/language/language.pipe';
import { ButtonComponent } from '../../feedback/button/button.component';

@Component({
  selector: 'aw-delete-payment-method-dialog',
  imports: [
    ReactiveFormsModule,
    DialogComponent,
    FilterTextsPipe,
    LanguagePipe,
    ButtonComponent,
  ],
  templateUrl: './delete-payment-method-dialog.component.html',
})
export class DeletePaymentMethodDialogComponent extends Dialog<IDialogData> {
  protected readonly textStore: WebTextStore = inject(WebTextStore);

  protected readonly ERelationType: typeof ERelationType = ERelationType;
  protected readonly EEntityType: typeof EEntityType = EEntityType;
}
